export default __webpack_public_path__ + "0fc6cb6612eadfcb356fda3502700c2a.png";